import { z } from "zod";
import { NotificationSchema, NotificationPolicySchema } from "../entities";
import { NotificationStatusSchema } from "../enums";
import { IdSchema, pageOf } from "../primitives";

/** `GET /api/notifications`. */
export const ListNotificationsQuerySchema = z.object({
  status: NotificationStatusSchema.optional(),
  cursor: z.string().min(1).optional(),
  limit: z.coerce.number().int().min(1).max(100).optional(),
});
export type ListNotificationsQuery = z.infer<typeof ListNotificationsQuerySchema>;

export const ListNotificationsResponseSchema = pageOf(NotificationSchema);
export type ListNotificationsResponse = z.infer<typeof ListNotificationsResponseSchema>;

/** `POST /api/notifications/read` — omit `ids` to mark all as read. */
export const MarkNotificationsReadSchema = z.object({
  ids: z.array(IdSchema).optional(),
});
export type MarkNotificationsRead = z.infer<typeof MarkNotificationsReadSchema>;

export const MarkNotificationsReadResponseSchema = z.object({
  updated: z.number().int().nonnegative(),
});
export type MarkNotificationsReadResponse = z.infer<typeof MarkNotificationsReadResponseSchema>;

/** `GET /api/notifications/policy` and `PUT /api/notifications/policy`. */
export const NotificationPolicyResponseSchema = NotificationPolicySchema;
export type NotificationPolicyResponse = z.infer<typeof NotificationPolicyResponseSchema>;

export const UpdateNotificationPolicySchema = NotificationPolicySchema;
export type UpdateNotificationPolicy = z.infer<typeof UpdateNotificationPolicySchema>;
